module.exports = __webpack_public_path__ + "static/media/RLVR.4727529d.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/RLVR.JPG
// module id = 1468
// module chunks = 1